import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Avatar, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_THEME_COLOR } from 'appenv';

const ProfileAvatarSectionContainer = styled.div`
  text-align: center;
  padding-top: 8px;
`;

const ProfileAvatar = styled(Avatar)`
  width: 6rem;
  height: 6rem;
  display: inline-flex;
`;

const AvatarLabel = styled.label`
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`;

const EditProfilePictureButton = styled(Button)<{ themeColor?: string }>`
  text-transform: capitalize;
  margin-top: 16px;
  color: ${({ themeColor }) => (themeColor || DEFAULT_THEME_COLOR)};
`;

const ProfileAvatarSection = ({
  onAvatarChange, showEditButton = false, avatar, className,
}: {
  onAvatarChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  showEditButton?: boolean;
  avatar: string;
  className?: string;
}) => {
  const fileInputRef = useRef<HTMLInputElement>();
  const { t } = useTranslation();
  const themeColor = useSelector((s) => s.eventConfigs.themeColor);

  const forceAvatarClick = useCallback(() => fileInputRef.current?.click(), []);

  return (
    <ProfileAvatarSectionContainer className={className} id="profile-avatar-container">
      <input
        accept="image/*"
        style={{ display: 'none' }}
        id="raised-button-file"
        type="file"
        ref={fileInputRef}
        onChange={onAvatarChange}
      />
      <AvatarLabel htmlFor="raised-button-file">
        <ProfileAvatar src={avatar} id="profile-avatar" />
        {showEditButton && (
          <EditProfilePictureButton
            variant="text"
            id="edit-profile-picture-button"
            themeColor={themeColor}
            onClick={forceAvatarClick}
          >
            {t('profile.edit_picture')}
          </EditProfilePictureButton>
        )}
      </AvatarLabel>
    </ProfileAvatarSectionContainer>
  );
};

export default ProfileAvatarSection;
